// Complete translations for Fabrikov website - CZ, PL, DE, EN

export const translations = {
  cs: {
    floating: { inquiry: 'Nezávazná poptávka', call: 'Zavolat' },
    review: { title: 'Jste s námi spokojeni?', text: 'Budeme rádi za vaše hodnocení na Googlu.', button: 'Ohodnoťte nás na Googlu' },
    // Header / Navigation
    nav: {
      home: 'Úvod',
      about: 'O nás',
      services: 'Služby',
      gallery: 'Realizace',
      contact: 'Kontakt',
    },
    // Home page
    home: {
      heroTitle1: 'Vyrábíme řešení',
      heroTitle2: 'na míru',
      heroSubtitle: 'Zakázková kovovýroba | 3D tisk | Laserové gravírování | Pronájem lešení',
      heroDescription: 'Profesionální zpracování kovů, moderní 3D tisk a precizní gravírování. Od návrhu až po realizaci.',
      ctaQuote: 'Nezávazná poptávka',
      servicesTitle: 'Naše služby',
      servicesSubtitle: 'Komplexní řešení pro vaše projekty',
      moreInfo: 'Více informací',
      ctaTitle: 'Máte projekt na míru?',
      ctaText: 'Kontaktujte nás a probereme vaše požadavky. Nabídneme řešení přesně pro vás.',
      ctaButton: 'Napište nám',
    },
    // About page
    about: {
      title: 'O nás',
      headline: 'Kvalita a preciznost na prvním místě',
      p1: 'Jsme rodinná firma z Frýdlantu, která se zabývá zakázkovou kovovýrobou, 3D tiskem, laserovým gravírováním a pronájmem lešení. Naše práce je založena na individuálním přístupu ke každému zákazníkovi a důrazu na kvalitu zpracování.',
      p2: 'Díky modernímu vybavení dílny a dlouholetým zkušenostem dokážeme realizovat projekty od drobných oprav až po komplexní zakázky. Každý výrobek vyrábíme s maximální péčí a přesností.',
      p3: 'Nabízíme kompletní servis od konzultace, přes návrh a výrobu až po finální montáž. Vaše spokojenost je naší prioritou.',
      qualityTitle: 'Kvalita',
      qualityText: 'Každý výrobek vyrábíme s maximální péčí a přesností. Kvalita je naší prioritou.',
      approachTitle: 'Individuální přístup',
      approachText: 'Každý zákazník je pro nás jedinečný. Nasloucháme vašim potřebám a hledáme optimální řešení.',
      customTitle: 'Výroba na míru',
      customText: 'Od konzultace přes návrh až po realizaci. Vaše vize je náš cíl.',
    },
    // Services page
    services: {
      title: 'Naše služby',
      subtitle: 'Komplexní řešení pro vaše projekty – od návrhu po realizaci',
      usesTitle: 'Využití:',
      ctaTitle: 'Potřebujete poradit s výběrem služby?',
      ctaText: 'Kontaktujte nás a společně najdeme nejvhodnější řešení pro váš projekt.',
      ctaButton: 'Kontaktovat nás',
      items: {
        metalwork: {
          title: 'Zakázková kovovýroba',
          description: 'Profesionální zpracování kovu na míru vašim potřebám. Specializujeme se na precizní svařování, CNC obrábění a výrobu kovových konstrukcí.',
          uses: [
            'Kovové konstrukce a rámy',
            'Svařované díly a sestavy',
            'CNC soustružení a frézování',
            'Přesné opracování kovů',
            'Renovace a opravy',
          ],
        },
        print3d: {
          title: '3D tisk',
          description: 'Rychlá výroba prototypů a funkčních dílů pomocí moderních 3D tiskáren. Od návrhu po finální výrobek.',
          uses: [
            'Prototypy a funkční modely',
            'Náhradní díly',
            'Designové komponenty',
            'Přípravky a formy',
            'Vizualizace projektů',
          ],
        },
        engraving: {
          title: 'Laserové gravírování',
          description: 'Precizní gravírování do kovů, plastů a dalších materiálů. Personalizace, značení a dekorativní úpravy.',
          uses: [
            'Personalizované dárky',
            'Označení výrobků a nářadí',
            'Reklamní předměty',
            'Štítky a tabulky',
            'Umělecké gravury',
          ],
        },
        scaffolding: {
          title: 'Pronájem lešení',
          description: 'Nabízíme pronájem kvalitního stavebního lešení pro vaše projekty. Spolehlivé, bezpečné a flexibilní řešení pro každou stavbu.',
          uses: [
            'Rekonstrukce fasád a budov',
            'Nátěry a omítky',
            'Stavební a izolační práce',
            'Krátkodobý i dlouhodobý pronájem',
            'Doprava a montáž na klíč',
          ],
        },
      },
    },
    // Gallery page
    gallery: {
      title: 'Realizace',
      subtitle: 'Naše práce mluví za nás – podívejte se na ukázky našich projektů',
      empty: 'Galerie je zatím prázdná. Obrázky můžete přidat v admin panelu.',
      filters: {
        all: 'Vše',
        metalwork: 'Kovovýroba',
        print3d: '3D tisk',
        engraving: 'Gravírování',
        scaffolding: 'Lešení',
      },
    },
    // Contact page
    contact: {
      attachLabel: 'Přílohy (nepovinné)',
      attachButton: 'Přiložit fotky, PDF nebo výkresy',
      attachHint: 'JPG, PNG, WEBP, HEIC, PDF, DWG, DXF · max. 5 souborů po 10 MB',
      attachBadType: 'nepodporovaný typ souboru',
      attachTooBig: 'soubor je větší než 10 MB',
      attachFailed: 'nahrání se nezdařilo',
      title: 'Kontakt',
      subtitle: 'Máte dotaz nebo požadavek? Neváhejte nás kontaktovat',
      infoTitle: 'Kontaktní informace',
      email: 'E-mail',
      phone: 'Telefon',
      address: 'Adresa',
      companyDesc: 'Rodinná firma specializující se na zakázkovou kovovýrobu, 3D tisk, laserové gravírování a pronájem lešení.',
      formTitle: 'Napište nám',
      labelName: 'Jméno *',
      labelEmail: 'E-mail *',
      labelPhone: 'Telefon',
      labelMessage: 'Zpráva *',
      placeholderName: 'Vaše jméno',
      placeholderEmail: 'vas@email.cz',
      placeholderPhone: '+420 123 456 789',
      placeholderMessage: 'Popište svůj požadavek nebo dotaz...',
      sending: 'Odesílám...',
      send: 'Odeslat zprávu',
      successMsg: 'Zpráva byla odeslána',
      errorMsg: 'Něco se pokazilo. Zkuste to prosím znovu.',
    },
    // Footer
    footer: {
      desc: 'Zakázková kovovýroba, 3D tisk, laserové gravírování a pronájem lešení. Kvalita a preciznost na prvním místě.',
      quickLinks: 'Rychlé odkazy',
      copyright: 'Všechna práva vyhrazena.',
    },
    // Admin
    admin: {
      loginTitle: 'Admin přihlášení',
      loginSubtitle: 'Přihlaste se pro přístup k admin panelu',
      labelEmail: 'Email',
      labelPassword: 'Heslo',
      loggingIn: 'Přihlašuji...',
      loginBtn: 'Přihlásit se',
      loginSuccess: 'Přihlášení úspěšné!',
      loginError: 'Chyba při přihlašování',
      dashboardTitle: 'Admin Panel - Správa Galerie',
      loggedInAs: 'Přihlášen jako:',
      logout: 'Odhlásit',
      uploadNew: 'Nahrát nový obrázek',
      uploadTitle: 'Název obrázku',
      uploadDesc: 'Popis',
      uploadCategory: 'Kategorie',
      uploadFile: 'Soubor (obrázek)',
      uploadBtn: 'Nahrát',
      cancel: 'Zrušit',
      save: 'Uložit',
      edit: 'Upravit',
      delete: 'Smazat',
      confirmDelete: 'Opravdu chcete smazat tento obrázek?',
      uploadSuccess: 'Obrázek úspěšně nahrán!',
      uploadError: 'Chyba při nahrávání',
      updateSuccess: 'Aktualizováno!',
      updateError: 'Chyba při aktualizaci',
      deleteSuccess: 'Smazáno!',
      deleteError: 'Chyba při mazání',
      loadError: 'Chyba při načítání galerie',
      noImages: 'Zatím nemáte žádné obrázky v galerii',
      filterAll: 'Vše',
    },
  },

  pl: {
    floating: { inquiry: 'Bezpłatna wycena', call: 'Zadzwoń' },
    review: { title: 'Jesteś zadowolony z naszej pracy?', text: 'Będziemy wdzięczni za opinię w Google.', button: 'Oceń nas w Google' },
    nav: {
      home: 'Start',
      about: 'O nas',
      services: 'Usługi',
      gallery: 'Realizacje',
      contact: 'Kontakt',
    },
    home: {
      heroTitle1: 'Tworzymy rozwiązania',
      heroTitle2: 'na miarę',
      heroSubtitle: 'Obróbka metalu | Druk 3D | Grawerowanie laserowe | Wynajem rusztowań',
      heroDescription: 'Profesjonalna obróbka metalu, nowoczesny druk 3D i precyzyjne grawerowanie. Od projektu po realizację.',
      ctaQuote: 'Bezpłatna wycena',
      servicesTitle: 'Nasze usługi',
      servicesSubtitle: 'Kompleksowe rozwiązania dla Twoich projektów',
      moreInfo: 'Więcej informacji',
      ctaTitle: 'Masz projekt na zamówienie?',
      ctaText: 'Skontaktuj się z nami, a omówimy Twoje wymagania. Zaproponujemy rozwiązanie dokładnie dla Ciebie.',
      ctaButton: 'Napisz do nas',
    },
    about: {
      title: 'O nas',
      headline: 'Jakość i precyzja na pierwszym miejscu',
      p1: 'Jesteśmy rodzinną firmą z Frýdlantu zajmującą się obróbką metalu, drukiem 3D, grawerowaniem laserowym i wynajmem rusztowań. Nasza praca opiera się na indywidualnym podejściu do każdego klienta i nacisku na jakość wykonania.',
      p2: 'Dzięki nowoczesnemu wyposażeniu warsztatu i wieloletniemu doświadczeniu realizujemy projekty od drobnych napraw po kompleksowe zlecenia. Każdy produkt wykonujemy z najwyższą starannością i precyzją.',
      p3: 'Oferujemy kompletny serwis od konsultacji, przez projekt i produkcję, aż po montaż końcowy. Twoja satysfakcja jest naszym priorytetem.',
      qualityTitle: 'Jakość',
      qualityText: 'Każdy produkt wykonujemy z najwyższą starannością i precyzją. Jakość jest naszym priorytetem.',
      approachTitle: 'Indywidualne podejście',
      approachText: 'Każdy klient jest dla nas wyjątkowy. Słuchamy Twoich potrzeb i szukamy optymalnych rozwiązań.',
      customTitle: 'Produkcja na zamówienie',
      customText: 'Od konsultacji przez projekt po realizację. Twoja wizja jest naszym celem.',
    },
    services: {
      title: 'Nasze usługi',
      subtitle: 'Kompleksowe rozwiązania dla Twoich projektów – od projektu po realizację',
      usesTitle: 'Zastosowanie:',
      ctaTitle: 'Potrzebujesz porady przy wyborze usługi?',
      ctaText: 'Skontaktuj się z nami, a wspólnie znajdziemy najlepsze rozwiązanie dla Twojego projektu.',
      ctaButton: 'Skontaktuj się z nami',
      items: {
        metalwork: {
          title: 'Obróbka metalu na zamówienie',
          description: 'Profesjonalna obróbka metalu dostosowana do Twoich potrzeb. Specjalizujemy się w precyzyjnym spawaniu, obróbce CNC i produkcji konstrukcji metalowych.',
          uses: [
            'Konstrukcje metalowe i ramy',
            'Spawane części i zespoły',
            'Toczenie i frezowanie CNC',
            'Precyzyjna obróbka metalu',
            'Renowacje i naprawy',
          ],
        },
        print3d: {
          title: 'Druk 3D',
          description: 'Szybka produkcja prototypów i funkcjonalnych części za pomocą nowoczesnych drukarek 3D. Od projektu po gotowy produkt.',
          uses: [
            'Prototypy i modele funkcjonalne',
            'Części zamienne',
            'Komponenty designerskie',
            'Przyrządy i formy',
            'Wizualizacje projektów',
          ],
        },
        engraving: {
          title: 'Grawerowanie laserowe',
          description: 'Precyzyjne grawerowanie w metalu, plastiku i innych materiałach. Personalizacja, znakowanie i ozdoby.',
          uses: [
            'Spersonalizowane prezenty',
            'Znakowanie produktów i narzędzi',
            'Materiały reklamowe',
            'Etykiety i tabliczki',
            'Grawerowanie artystyczne',
          ],
        },
        scaffolding: {
          title: 'Wynajem rusztowań',
          description: 'Oferujemy wynajem wysokiej jakości rusztowań budowlanych do Twoich projektów. Niezawodne, bezpieczne i elastyczne rozwiązanie dla każdej budowy.',
          uses: [
            'Renowacje elewacji i budynków',
            'Malowanie i tynkowanie',
            'Prace budowlane i izolacyjne',
            'Wynajem krótko- i długoterminowy',
            'Transport i montaż pod klucz',
          ],
        },
      },
    },
    gallery: {
      title: 'Realizacje',
      subtitle: 'Nasza praca mówi sama za siebie – zobacz przykłady naszych projektów',
      empty: 'Galeria jest jeszcze pusta. Obrazy możesz dodać w panelu administratora.',
      filters: {
        all: 'Wszystkie',
        metalwork: 'Obróbka metalu',
        print3d: 'Druk 3D',
        engraving: 'Grawerowanie',
        scaffolding: 'Rusztowania',
      },
    },
    contact: {
      attachLabel: 'Załączniki (opcjonalnie)',
      attachButton: 'Dołącz zdjęcia, PDF lub rysunki',
      attachHint: 'JPG, PNG, WEBP, HEIC, PDF, DWG, DXF · maks. 5 plików po 10 MB',
      attachBadType: 'nieobsługiwany typ pliku',
      attachTooBig: 'plik jest większy niż 10 MB',
      attachFailed: 'przesyłanie nie powiodło się',
      title: 'Kontakt',
      subtitle: 'Masz pytanie lub prośbę? Nie wahaj się z nami skontaktować',
      infoTitle: 'Informacje kontaktowe',
      email: 'E-mail',
      phone: 'Telefon',
      address: 'Adres',
      companyDesc: 'Rodzinna firma specjalizująca się w obróbce metalu, druku 3D, grawerowaniu laserowym i wynajmie rusztowań.',
      formTitle: 'Napisz do nas',
      labelName: 'Imię *',
      labelEmail: 'E-mail *',
      labelPhone: 'Telefon',
      labelMessage: 'Wiadomość *',
      placeholderName: 'Twoje imię',
      placeholderEmail: 'twoj@email.pl',
      placeholderPhone: '+48 123 456 789',
      placeholderMessage: 'Opisz swoją prośbę lub pytanie...',
      sending: 'Wysyłanie...',
      send: 'Wyślij wiadomość',
      successMsg: 'Wiadomość została wysłana',
      errorMsg: 'Coś poszło nie tak. Spróbuj ponownie.',
    },
    footer: {
      desc: 'Obróbka metalu, druk 3D, grawerowanie laserowe i wynajem rusztowań. Jakość i precyzja na pierwszym miejscu.',
      quickLinks: 'Szybkie linki',
      copyright: 'Wszelkie prawa zastrzeżone.',
    },
    admin: {
      loginTitle: 'Logowanie administratora',
      loginSubtitle: 'Zaloguj się, aby uzyskać dostęp do panelu administratora',
      labelEmail: 'Email',
      labelPassword: 'Hasło',
      loggingIn: 'Logowanie...',
      loginBtn: 'Zaloguj się',
      loginSuccess: 'Logowanie udane!',
      loginError: 'Błąd logowania',
      dashboardTitle: 'Panel administratora - Zarządzanie galerią',
      loggedInAs: 'Zalogowany jako:',
      logout: 'Wyloguj',
      uploadNew: 'Dodaj nowy obraz',
      uploadTitle: 'Tytuł obrazu',
      uploadDesc: 'Opis',
      uploadCategory: 'Kategoria',
      uploadFile: 'Plik (obraz)',
      uploadBtn: 'Prześlij',
      cancel: 'Anuluj',
      save: 'Zapisz',
      edit: 'Edytuj',
      delete: 'Usuń',
      confirmDelete: 'Czy na pewno chcesz usunąć ten obraz?',
      uploadSuccess: 'Obraz został pomyślnie przesłany!',
      uploadError: 'Błąd podczas przesyłania',
      updateSuccess: 'Zaktualizowano!',
      updateError: 'Błąd aktualizacji',
      deleteSuccess: 'Usunięto!',
      deleteError: 'Błąd usuwania',
      loadError: 'Błąd ładowania galerii',
      noImages: 'Nie masz jeszcze żadnych obrazów w galerii',
      filterAll: 'Wszystkie',
    },
  },

  de: {
    floating: { inquiry: 'Unverbindliche Anfrage', call: 'Anrufen' },
    review: { title: 'Sind Sie mit uns zufrieden?', text: 'Wir freuen uns über Ihre Bewertung auf Google.', button: 'Bewerten Sie uns auf Google' },
    nav: {
      home: 'Start',
      about: 'Über uns',
      services: 'Dienstleistungen',
      gallery: 'Referenzen',
      contact: 'Kontakt',
    },
    home: {
      heroTitle1: 'Wir fertigen Lösungen',
      heroTitle2: 'nach Maß',
      heroSubtitle: 'Metallverarbeitung | 3D-Druck | Lasergravur | Gerüstverleih',
      heroDescription: 'Professionelle Metallverarbeitung, moderner 3D-Druck und präzise Gravur. Vom Entwurf bis zur Umsetzung.',
      ctaQuote: 'Unverbindliche Anfrage',
      servicesTitle: 'Unsere Dienstleistungen',
      servicesSubtitle: 'Komplexe Lösungen für Ihre Projekte',
      moreInfo: 'Mehr Informationen',
      ctaTitle: 'Haben Sie ein maßgeschneidertes Projekt?',
      ctaText: 'Kontaktieren Sie uns und wir besprechen Ihre Anforderungen. Wir bieten Ihnen die passende Lösung.',
      ctaButton: 'Schreiben Sie uns',
    },
    about: {
      title: 'Über uns',
      headline: 'Qualität und Präzision an erster Stelle',
      p1: 'Wir sind ein Familienunternehmen aus Frýdlant, das sich auf Metallverarbeitung, 3D-Druck, Lasergravur und Gerüstverleih spezialisiert hat. Unsere Arbeit basiert auf einem individuellen Ansatz für jeden Kunden und der Betonung der Qualität.',
      p2: 'Dank moderner Werkstattausstattung und langjähriger Erfahrung können wir Projekte von kleinen Reparaturen bis hin zu komplexen Aufträgen realisieren. Jedes Produkt fertigen wir mit höchster Sorgfalt und Präzision.',
      p3: 'Wir bieten einen kompletten Service von der Beratung über den Entwurf und die Produktion bis hin zur Endmontage. Ihre Zufriedenheit ist unsere Priorität.',
      qualityTitle: 'Qualität',
      qualityText: 'Jedes Produkt fertigen wir mit höchster Sorgfalt und Präzision. Qualität ist unsere Priorität.',
      approachTitle: 'Individueller Ansatz',
      approachText: 'Jeder Kunde ist für uns einzigartig. Wir hören auf Ihre Bedürfnisse und suchen optimale Lösungen.',
      customTitle: 'Fertigung nach Maß',
      customText: 'Von der Beratung über den Entwurf bis zur Umsetzung. Ihre Vision ist unser Ziel.',
    },
    services: {
      title: 'Unsere Dienstleistungen',
      subtitle: 'Komplexe Lösungen für Ihre Projekte – vom Entwurf bis zur Umsetzung',
      usesTitle: 'Anwendungen:',
      ctaTitle: 'Benötigen Sie Beratung bei der Auswahl?',
      ctaText: 'Kontaktieren Sie uns und wir finden gemeinsam die beste Lösung für Ihr Projekt.',
      ctaButton: 'Kontakt aufnehmen',
      items: {
        metalwork: {
          title: 'Auftragsmetallverarbeitung',
          description: 'Professionelle Metallverarbeitung nach Ihren Bedürfnissen. Wir sind spezialisiert auf präzises Schweißen, CNC-Bearbeitung und die Herstellung von Metallkonstruktionen.',
          uses: [
            'Metallkonstruktionen und Rahmen',
            'Geschweißte Teile und Baugruppen',
            'CNC-Drehen und -Fräsen',
            'Präzise Metallbearbeitung',
            'Renovierungen und Reparaturen',
          ],
        },
        print3d: {
          title: '3D-Druck',
          description: 'Schnelle Herstellung von Prototypen und Funktionsteilen mit modernen 3D-Druckern. Vom Entwurf bis zum Endprodukt.',
          uses: [
            'Prototypen und Funktionsmodelle',
            'Ersatzteile',
            'Design-Komponenten',
            'Vorrichtungen und Formen',
            'Projektvisualisierungen',
          ],
        },
        engraving: {
          title: 'Lasergravur',
          description: 'Präzise Gravur in Metall, Kunststoff und anderen Materialien. Personalisierung, Kennzeichnung und dekorative Bearbeitung.',
          uses: [
            'Personalisierte Geschenke',
            'Kennzeichnung von Produkten und Werkzeugen',
            'Werbeartikel',
            'Schilder und Tafeln',
            'Künstlerische Gravuren',
          ],
        },
        scaffolding: {
          title: 'Gerüstverleih',
          description: 'Wir bieten den Verleih hochwertiger Baugerüste für Ihre Projekte an. Zuverlässige, sichere und flexible Lösung für jede Baustelle.',
          uses: [
            'Sanierung von Fassaden und Gebäuden',
            'Anstriche und Putzarbeiten',
            'Bau- und Isolierarbeiten',
            'Kurz- und Langzeitvermietung',
            'Transport und Montage schlüsselfertig',
          ],
        },
      },
    },
    gallery: {
      title: 'Referenzen',
      subtitle: 'Unsere Arbeit spricht für sich – sehen Sie Beispiele unserer Projekte',
      empty: 'Die Galerie ist noch leer. Bilder können Sie im Admin-Panel hinzufügen.',
      filters: {
        all: 'Alle',
        metalwork: 'Metallverarbeitung',
        print3d: '3D-Druck',
        engraving: 'Gravur',
        scaffolding: 'Gerüste',
      },
    },
    contact: {
      attachLabel: 'Anhänge (optional)',
      attachButton: 'Fotos, PDF oder Zeichnungen anhängen',
      attachHint: 'JPG, PNG, WEBP, HEIC, PDF, DWG, DXF · max. 5 Dateien à 10 MB',
      attachBadType: 'nicht unterstützter Dateityp',
      attachTooBig: 'Datei ist größer als 10 MB',
      attachFailed: 'Hochladen fehlgeschlagen',
      title: 'Kontakt',
      subtitle: 'Haben Sie eine Frage oder Anfrage? Zögern Sie nicht, uns zu kontaktieren',
      infoTitle: 'Kontaktinformationen',
      email: 'E-Mail',
      phone: 'Telefon',
      address: 'Adresse',
      companyDesc: 'Familienunternehmen spezialisiert auf Metallverarbeitung, 3D-Druck, Lasergravur und Gerüstverleih.',
      formTitle: 'Schreiben Sie uns',
      labelName: 'Name *',
      labelEmail: 'E-Mail *',
      labelPhone: 'Telefon',
      labelMessage: 'Nachricht *',
      placeholderName: 'Ihr Name',
      placeholderEmail: 'ihre@email.de',
      placeholderPhone: '+49 123 456 789',
      placeholderMessage: 'Beschreiben Sie Ihre Anfrage oder Frage...',
      sending: 'Wird gesendet...',
      send: 'Nachricht senden',
      successMsg: 'Nachricht wurde gesendet',
      errorMsg: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    },
    footer: {
      desc: 'Metallverarbeitung, 3D-Druck, Lasergravur und Gerüstverleih. Qualität und Präzision an erster Stelle.',
      quickLinks: 'Schnelllinks',
      copyright: 'Alle Rechte vorbehalten.',
    },
    admin: {
      loginTitle: 'Admin-Anmeldung',
      loginSubtitle: 'Melden Sie sich an, um auf das Admin-Panel zuzugreifen',
      labelEmail: 'E-Mail',
      labelPassword: 'Passwort',
      loggingIn: 'Anmelden...',
      loginBtn: 'Anmelden',
      loginSuccess: 'Anmeldung erfolgreich!',
      loginError: 'Anmeldefehler',
      dashboardTitle: 'Admin-Panel - Galerie verwalten',
      loggedInAs: 'Angemeldet als:',
      logout: 'Abmelden',
      uploadNew: 'Neues Bild hochladen',
      uploadTitle: 'Bildtitel',
      uploadDesc: 'Beschreibung',
      uploadCategory: 'Kategorie',
      uploadFile: 'Datei (Bild)',
      uploadBtn: 'Hochladen',
      cancel: 'Abbrechen',
      save: 'Speichern',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      confirmDelete: 'Möchten Sie dieses Bild wirklich löschen?',
      uploadSuccess: 'Bild erfolgreich hochgeladen!',
      uploadError: 'Fehler beim Hochladen',
      updateSuccess: 'Aktualisiert!',
      updateError: 'Fehler beim Aktualisieren',
      deleteSuccess: 'Gelöscht!',
      deleteError: 'Fehler beim Löschen',
      loadError: 'Fehler beim Laden der Galerie',
      noImages: 'Sie haben noch keine Bilder in der Galerie',
      filterAll: 'Alle',
    },
  },

  en: {
    floating: { inquiry: 'Free quote', call: 'Call us' },
    review: { title: 'Happy with our work?', text: 'We would appreciate your review on Google.', button: 'Rate us on Google' },
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      gallery: 'Gallery',
      contact: 'Contact',
    },
    home: {
      heroTitle1: 'Custom solutions',
      heroTitle2: 'made for you',
      heroSubtitle: 'Custom Metalwork | 3D Printing | Laser Engraving | Scaffolding Rental',
      heroDescription: 'Professional metal processing, modern 3D printing, and precise engraving. From design to realization.',
      ctaQuote: 'Free quote',
      servicesTitle: 'Our services',
      servicesSubtitle: 'Comprehensive solutions for your projects',
      moreInfo: 'More information',
      ctaTitle: 'Have a custom project?',
      ctaText: 'Contact us and we will discuss your requirements. We will offer you the perfect solution.',
      ctaButton: 'Write to us',
    },
    about: {
      title: 'About us',
      headline: 'Quality and precision first',
      p1: 'We are a family business from Frýdlant specializing in custom metalwork, 3D printing, laser engraving, and scaffolding rental. Our work is based on an individual approach to each customer and emphasis on quality of workmanship.',
      p2: 'Thanks to modern workshop equipment and many years of experience, we can carry out projects from small repairs to comprehensive orders. We make every product with maximum care and precision.',
      p3: 'We offer complete service from consultation, through design and production, to final assembly. Your satisfaction is our priority.',
      qualityTitle: 'Quality',
      qualityText: 'We make every product with maximum care and precision. Quality is our priority.',
      approachTitle: 'Individual approach',
      approachText: 'Every customer is unique to us. We listen to your needs and look for optimal solutions.',
      customTitle: 'Custom production',
      customText: 'From consultation through design to realization. Your vision is our goal.',
    },
    services: {
      title: 'Our services',
      subtitle: 'Comprehensive solutions for your projects – from design to realization',
      usesTitle: 'Applications:',
      ctaTitle: 'Need advice choosing a service?',
      ctaText: 'Contact us and together we will find the best solution for your project.',
      ctaButton: 'Contact us',
      items: {
        metalwork: {
          title: 'Custom Metalwork',
          description: 'Professional metal processing tailored to your needs. We specialize in precise welding, CNC machining, and the production of metal structures.',
          uses: [
            'Metal structures and frames',
            'Welded parts and assemblies',
            'CNC turning and milling',
            'Precise metal processing',
            'Renovations and repairs',
          ],
        },
        print3d: {
          title: '3D Printing',
          description: 'Fast production of prototypes and functional parts using modern 3D printers. From design to final product.',
          uses: [
            'Prototypes and functional models',
            'Spare parts',
            'Design components',
            'Jigs and molds',
            'Project visualizations',
          ],
        },
        engraving: {
          title: 'Laser Engraving',
          description: 'Precise engraving in metals, plastics, and other materials. Personalization, marking, and decorative finishes.',
          uses: [
            'Personalized gifts',
            'Marking of products and tools',
            'Promotional items',
            'Labels and plaques',
            'Artistic engravings',
          ],
        },
        scaffolding: {
          title: 'Scaffolding Rental',
          description: 'We offer rental of high-quality construction scaffolding for your projects. Reliable, safe, and flexible solution for any construction site.',
          uses: [
            'Facade and building renovations',
            'Painting and plastering',
            'Construction and insulation work',
            'Short and long term rental',
            'Transport and turnkey assembly',
          ],
        },
      },
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Our work speaks for itself – see examples of our projects',
      empty: 'The gallery is empty. You can add images in the admin panel.',
      filters: {
        all: 'All',
        metalwork: 'Metalwork',
        print3d: '3D Printing',
        engraving: 'Engraving',
        scaffolding: 'Scaffolding',
      },
    },
    contact: {
      attachLabel: 'Attachments (optional)',
      attachButton: 'Attach photos, PDF or drawings',
      attachHint: 'JPG, PNG, WEBP, HEIC, PDF, DWG, DXF · max. 5 files, 10 MB each',
      attachBadType: 'unsupported file type',
      attachTooBig: 'file is larger than 10 MB',
      attachFailed: 'upload failed',
      title: 'Contact',
      subtitle: 'Have a question or request? Don\'t hesitate to contact us',
      infoTitle: 'Contact information',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      companyDesc: 'Family business specializing in custom metalwork, 3D printing, laser engraving, and scaffolding rental.',
      formTitle: 'Write to us',
      labelName: 'Name *',
      labelEmail: 'Email *',
      labelPhone: 'Phone',
      labelMessage: 'Message *',
      placeholderName: 'Your name',
      placeholderEmail: 'your@email.com',
      placeholderPhone: '+1 234 567 890',
      placeholderMessage: 'Describe your request or question...',
      sending: 'Sending...',
      send: 'Send message',
      successMsg: 'Message has been sent',
      errorMsg: 'Something went wrong. Please try again.',
    },
    footer: {
      desc: 'Custom metalwork, 3D printing, laser engraving, and scaffolding rental. Quality and precision first.',
      quickLinks: 'Quick links',
      copyright: 'All rights reserved.',
    },
    admin: {
      loginTitle: 'Admin Login',
      loginSubtitle: 'Log in to access the admin panel',
      labelEmail: 'Email',
      labelPassword: 'Password',
      loggingIn: 'Logging in...',
      loginBtn: 'Log in',
      loginSuccess: 'Login successful!',
      loginError: 'Login error',
      dashboardTitle: 'Admin Panel - Gallery Management',
      loggedInAs: 'Logged in as:',
      logout: 'Log out',
      uploadNew: 'Upload new image',
      uploadTitle: 'Image title',
      uploadDesc: 'Description',
      uploadCategory: 'Category',
      uploadFile: 'File (image)',
      uploadBtn: 'Upload',
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Do you really want to delete this image?',
      uploadSuccess: 'Image uploaded successfully!',
      uploadError: 'Error during upload',
      updateSuccess: 'Updated!',
      updateError: 'Update error',
      deleteSuccess: 'Deleted!',
      deleteError: 'Delete error',
      loadError: 'Error loading gallery',
      noImages: 'You don\'t have any images in the gallery yet',
      filterAll: 'All',
    },
  },
};

// List of available languages with their flags/labels
export const LANGUAGES = [
  { code: 'cs', label: 'CZ', name: 'Čeština' },
  { code: 'pl', label: 'PL', name: 'Polski' },
  { code: 'de', label: 'DE', name: 'Deutsch' },
  { code: 'en', label: 'EN', name: 'English' },
];

export const DEFAULT_LANGUAGE = 'cs';
